import { render, staticRenderFns } from "./seeCode.vue?vue&type=template&id=12286432&scoped=true"
import script from "./seeCode.vue?vue&type=script&lang=js"
export * from "./seeCode.vue?vue&type=script&lang=js"
import style0 from "./seeCode.vue?vue&type=style&index=0&id=12286432&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12286432",
  null
  
)

export default component.exports